import AnnouncementItem from './AnnouncementItem';

export default AnnouncementItem;
